export const ACCESS_REQUEST_MESSAGES = {
  BANNER: {
    DISMISSED: {
      title: "Atenção!",
      message: "Funcionário demitido - Não é possível criar solicitação.",
    },
    BLOCKED: {
      title: "Bloqueado!",
      message: "Solicitação não permitida para este usuário.",
    },
    SUCCESS: {
      title: "Sucesso!",
      message: "Validação concluída com sucesso.",
    },
    ERROR: {
      title: "Erro!",
      message:
        "Ocorreu um erro ao validar o CPF. Tente novamente mais tarde. Caso o erro persista, entre em contato com o suporte.",
    },
    NOT_FOUND: {
      message:
        "Não identificamos o CPF informado na nossa base de funcionários. Valide o CPF e tente novamente. Caso necessário, entre em contato com o time financeiro.",
    },
    OFFICE_EMPLOYEE: {
      title: "Atenção!",
      message:
        "Atenção: este CPF não está apto para criação de usuário, pois não é um colaborador de loja. Verifique o CPF informado ou entre em contato com o time financeiro para mais informações.",
    },
    PENDING_TRAINING: {
      title: "Treinamento obrigatório pendente",
      message: (cursosPendentes: string) =>
        `Atenção, não foi possível criar os acessos porque o colaborador não realizou os treinamentos:\n${cursosPendentes}`,
    },
  },
  VALIDATION: {
    FETCHING: "Buscando e validando usuário...",
    INVALID_CPF: "CPF inválido",
  },
  TOOLTIP: {
    CPF: "Digite o CPF e aguarde a busca e validação do usuário automática",
  },
  PLACEHOLDERS: {
    CPF: "000.000.000-00",
    NAME: "Nome Completo",
    REGISTER: "000000",
    POSITION: "Cargo",
  },
  LABELS: {
    CPF: "CPF",
    NAME: "Nome",
    REGISTER: "Matrícula",
    POSITION: "Cargo",
    SITUATION: "Situação",
    COST_CENTER: "Centro de Custo",
  },
  CARD: {
    TITLE: "Usuário",
    DESCRIPTION: "Digite os dados do usuário que deseja solicitar acesso",
  },
} as const;